import React from "react";

const ButtonIcon = ({ children, className, size = "default", ...props }) => (
  <button type="button" className={`pos-btn-icon ${className}`} {...props}>
    <span>{children}</span>
  </button>
);

export default ButtonIcon;
